import TableData from "./tabledata"

// Luokka, joka sisältää datatyypin modalin erityyppisille sisällöille.
export default class DynamicModalData {
    constructor(
        id: string | null = null,
        header: string | null = null,
        textContent: string | null = null,
        count: number | null = null,
        tableData: TableData | null = null) {
            this.id = id
            this.header = header
            this.textContent = textContent
            this.count = count
            this.tableData = tableData
        }

    id?: string | null
    header?: string | null
    textContent?: string | null
    count?: number | null
    tableData?: TableData | null

    toJsonObject(): any {
        return {
            id: this.id,
            header: this.header,
            textContent: this.textContent,
            count: this.count,
            tableData: this.tableData
        }
    }

    static empty(): any {
        return new DynamicModalData("")
    }
}
